import React from 'react';
import { styled } from '@linaria/react';
import { getProviderIcon, getProviderName, getSvgProviderLogo } from '@daedalus/core/src/offer/business/provider';
import { ICON_HEIGHT, LOGO_HEIGHT } from './constants';
export type ProviderLogoVariant = 'logo' | 'icon';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Which provider's logo to display */
  providerCode: string;
  /** The variant of the logo to display */
  variant?: ProviderLogoVariant;
  /** The height of the image */
  height?: number;
  loading?: 'eager' | 'lazy';
}
const _exp2 = /*#__PURE__*/() => ({
  variant,
  height
}) => height ? height : variant === 'logo' ? LOGO_HEIGHT : ICON_HEIGHT;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1yqwp7c",
  propsAsIs: false,
  vars: {
    "w1yqwp7c-0": [_exp2(), "px"]
  }
});
export const ProviderLogo = ({
  providerCode,
  variant = 'logo',
  height,
  className,
  loading = 'lazy'
}: Props) => {
  const providerName = getProviderName(providerCode);
  const url = variant === 'logo' ? getSvgProviderLogo({
    providerCode
  }) : getProviderIcon({
    providerCode
  });
  return <Wrapper variant={variant} height={height} className={className}>
      <img src={url} alt={`${providerCode}-logo`} title={providerName} height={height} loading={loading} />
    </Wrapper>;
};

require("./ProviderLogo.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProviderLogo.tsx");